export class MachineOutput {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.carrierId = item.carrierId;
      this.type = item.type;
      this.manufacturer = item.manufacturer;
      this.weightCategoryId = item.weightCategoryId;
      this.weightCategory = item.weightCategoryDescription;
      this.weightCategoryDescription = item.weightCategoryDescription;
      this.weightCategoryName = item.weightCategoryName;
      this.model = item.model;
      this.statusName = item.statusName;
      this.attachmentPointConfigurations = item.attachmentPointConfigurations
        ? item.attachmentPointConfigurations.map(
            (x) => new AttachmentPointConfigurationOuput(x)
          )
        : [];
      return;
    }
    this.id = null;
    this.carrierId = null;
    this.type = null;
    this.manufacturer = null;
    this.weightCategoryId = null;
    this.weightCategory = null;
    this.weightCategoryName = null;
    this.weightCategoryDescription = null;
    this.model = '';
    this.statusName = '';
    this.attachmentPointConfigurations = [];
  }
}

export class AttachmentPointConfigurationOuput {
  constructor(item) {
    if (item) {
      this.attachmentPointId = item.attachmentPointId;
      this.attachmentPointName = item.attachmentPointName || '';
      this.oemPinUpId = item.oemPinUpId;
      this.oemPinUpName = item.oemPinUpName || '';
      return;
    }
  }
}
